import React from 'react'
import CreateNewCircleDecorator from "../../containers/CreateNewCircleDecorator";
import { Translate } from "react-redux-i18n";

import {
    Button,
    Card,
    Elevation    
  } from "@blueprintjs/core";
  
import {AddCircleOutline} from '@material-ui/icons/';

const NewCircleCard=({props}) => {
  return (
      <CreateNewCircleDecorator  empty_circle >
        <Card
            interactive={true}
            elevation={Elevation.ONE}
            className="cta-hero-card half-grid flex-col-center">
            <AddCircleOutline className="icon primary-color" size="48" />
            <h1>
                <Translate value="new_circle.heading"/>
            </h1>            
            <p>
                <Translate value="new_circle.subheading"/>
            </p>            
              <Button intent="primary" className="cta" fill={true}>
                  <Translate value="new_circle.create"/>
              </Button>
        </Card>
      </CreateNewCircleDecorator>
  )
}

export default NewCircleCard;
